<template>
    <div class="item-card item-card--display-promo" @click="handleClick" :class="['background-' + item.background_color]">
        <!-- Promo -->
        <div class="promo">
            <div class="inner">
                <span class="top-heading">
                    {{ item.top_heading }}
                </span>

                <strong class="heading" v-html="item.heading.join('<br />')"></strong>

                <a href="#" class="call-to-action stretched-link">
                    {{ item.call_to_action }}
                </a>
            </div>
        </div>

        <!-- Name -->
        <span class="name" v-if="item.name">
            {{ item.name }}
        </span>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {
            handleClick() {
                this.$emit('click', this.item)
            },
        },
        watch: {}
    }
</script>
